import React, { useState } from "react";
import { Link as RouterLink, useNavigate} from "react-router-dom";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios"


import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Link,
  Stack,
  TextField,
  Alert, Fade
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Icon } from "@iconify/react";
import { motion } from "framer-motion";

let easing = [0.6, -0.05, 0.01, 0.99];
const animate = {
  opacity: 1,
  y: 0,
  transition: {
    duration: 0.6,
    ease: easing,
    delay: 0.16,
  },
};

const SigninForm = ({ setAuth }) => {

  const url = process.env.REACT_APP_ENV === "DEV" ? process.env.REACT_APP_API_URL_DEV : process.env.REACT_APP_API_URL;
  const [result, setResult] = useState({severity: null, message: ""});

  const [showPassword, setShowPassword] = useState(false);

  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email("Provide a valid email address")
      .required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  const navigate = useNavigate();

  const handleLogin = (values, formikHelpers) => {

        console.log("submitting...");
        axios
        .post( url, values, {
            validateStatus: function (status) {
                return status < 500;  // <-- 401 bile then'e düşer
            },
            withCredentials: true
        })
        .then(response => {
                console.log('Login response data', response.data);

                setResult({message: response.data.message, severity: response.data.severity}); 

                if(response.data.code === 200){
                        setTimeout(()=>{
                            window.location.href = response.data.redirect;
                            formikHelpers.setSubmitting( false );
                        }, 1300 );
                        return;
                }
                formikHelpers.setSubmitting( false );
        
            }).catch( error => {
                    setResult({message: error.message, severity: 'error'});
                    formikHelpers.setSubmitting( false );
            }).finally(() => {
                console.log('Finally...');
            })

  }

  const handleLogin2 = (values, formikHelpers) => {
        fetch( url , {
            method: "POST",
            // credentials: "include", // <-- session cookie göndermek için
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(values),
        })
        .then( res => {
                if (!res.ok) throw new Error("Network response was not ok");
                return res.json();
        })
        .then( data => {
            console.log('Login response data', data.data);
        })
        .catch( err => {
            setResult({message: err.message, severity: 'error'});
        })
        .finally(() => {
            console.log('Finally...');
            formikHelpers.setSubmitting( false );
        });
  }

 

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      remember: false,
    },
    validationSchema: LoginSchema,
    onSubmit: handleLogin,
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  console.log('Formik values', result);

  return (
    <React.Fragment>
      { result?.message &&
        <Fade in={true}>
          <Alert sx={{mb:3}} severity={result.severity}>{ result.message }</Alert>
        </Fade>
      }

      <FormikProvider value={formik}>
        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
          <Box
              component={motion.div}
              animate={{
                transition: {
                  staggerChildren: 0.55,
                },
              }}
          >
            <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 3,
                }}
                component={motion.div}
                initial={{ opacity: 0, y: 40 }}
                animate={animate}
            >
              <TextField
                  //variant={'filled'}
                  fullWidth
                  autoComplete="username"
                  type="email"
                  label="Email Address"
                  {...getFieldProps("email")}
                  error={Boolean(touched.email && errors.email)}
                  helperText={touched.email && errors.email}
              />

              <TextField
                  fullWidth
                  autoComplete="current-password"
                  type={showPassword ? "text" : "password"}
                  label="Password"
                  {...getFieldProps("password")}
                  error={Boolean(touched.password && errors.password)}
                  helperText={touched.password && errors.password}
                  InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                              onClick={() => setShowPassword((prev) => !prev)}
                          >
                            {showPassword ? (
                                <Icon icon="eva:eye-fill" />
                            ) : (
                                <Icon icon="eva:eye-off-fill" />
                            )}
                          </IconButton>
                        </InputAdornment>
                    ),
                  }}
              />

            </Box>

            <Box
                component={motion.div}
                initial={{ opacity: 0, y: 20 }}
                animate={animate}
            >
              <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ my: 2 }}
              >
                <FormControlLabel
                    control={
                      <Checkbox
                          {...getFieldProps("remember")}
                          checked={values._remember_me}
                          name={'_remember_me'}
                      />
                    }
                    label="Remember me"
                />

                <Link
                    component={RouterLink}
                    variant="subtitle2"
                    to="/password-forgot"
                    underline="hover"
                >
                  Forgot password?
                </Link>
              </Stack>

              <LoadingButton
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                  loading={isSubmitting}
              >
                {isSubmitting ? "loading..." : "Login"}
              </LoadingButton>

            </Box>
          </Box>
        </Form>
      </FormikProvider>
    </React.Fragment>
  );
};

export default SigninForm;
